import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { readableHiddenContent } from '../../common/styles';
import messages from '../messages';
import { useMediaQuery } from '../../common/hooks';
import { LgLogo, MdLogo } from '../assets';

const S = {
  Title: styled.span`
    ${readableHiddenContent}
  `,
};

const Logo = ({ className, location }) => {
  const matches = useMediaQuery('(min-width: 1334px)');

  return (
    <h1 className={className}>
      <Link
        to={{
          pathname: '/schools',
          state: { from: location.pathname },
        }}
      >
        <S.Title>
          <FormattedMessage {...messages.logoTitle} />
        </S.Title>
        {matches ? <LgLogo /> : <MdLogo />}
      </Link>
    </h1>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

Logo.defaultProps = {
  className: undefined,
};

export default withRouter(Logo);
